import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const SystemWideSubLedgerHub = Loadable(lazy(() => import('./SystemWideSubLedgerHub/SystemWideSubLedgerHub')));

const subLedgerRoutes = [
    { path: '/subledger/hub', element: <SystemWideSubLedgerHub />, auth: authRoles.guest },
];

export default subLedgerRoutes;
